import React from 'react';
import { StyledColumns } from './styles';

interface IColumns {
  className?: string;
  style?: any;
  children?: any;
  justify?: string;
  display?: string;
}

export const Columns = ({
  className,
  style,
  children,
  justify,
  display,
}: IColumns) => (
  <StyledColumns
    className={className}
    style={style}
    justify={justify}
    display={display}
  >
    {children}
  </StyledColumns>
);
